import { faker } from '@faker-js/faker'

import { GroupedServiceOfferView, TargetLanguage } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getGroupedServiceOffer = asBuilder((): GroupedServiceOfferView => {
  return {
    id: faker.number.int(),
    title: faker.string.uuid(),
    groupId: faker.string.uuid(),
    targetLanguage: faker.helpers.enumValue(TargetLanguage),
    treatmentIds: faker.helpers.multiple(() => faker.number.int()),
  }
})
